import { render, staticRenderFns } from "./ConferencesList.vue?vue&type=template&id=2e0ee7a9"
import script from "./ConferencesList.vue?vue&type=script&lang=js"
export * from "./ConferencesList.vue?vue&type=script&lang=js"
import style0 from "./ConferencesList.vue?vue&type=style&index=0&id=2e0ee7a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports